import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { countryListActions, selectCountryList } from "Features/utils";
import { func, number, oneOfType, string } from "prop-types";
import { useDispatch, useSelector } from "react-redux";

export const CountrySelectEntity = ({ value, onChange, status }) => {
	const dispatch = useDispatch();
	const countryList = useSelector(selectCountryList.list);
	const countryFetch = useSelector(selectCountryList.fetch);
	const [options, setOptions] = useState([]);

	useEffect(() => {
		getCountry();
	}, []);

	useEffect(() => {
		setOptions(
			countryList.map((country) => {
				return {
					label: country.name,
					value: country.id,
				};
			}),
		);
	}, [countryList]);

	function getCountry() {
		dispatch(countryListActions.get());
	}

	return <Select value={value} options={options} loading={countryFetch} onChange={onChange} status={status} />;
};

CountrySelectEntity.propTypes = {
	value: oneOfType([string, number]),
	onChange: func,
	status: string,
};
